import Axios from '../config/Axios';

/**
 * Retorna uma lista de parceiros para usar como opções em um elemento <Select>.
 * @returns {Promise<[{ value: number, label: string }]>}
 * - `value` é o wlpn_nid do parceiro; quando o `value` de um item da lista for -1, é a opção "Acredite-se"
 * - `label` é o wlpn_cname do parceiro
 */
export const getPartnerOptions = async () => {
  const oResponse = await Axios.get('/wlpartner/options');
  return oResponse.data;
};

export const getPartners = async () => {
  const oResponse = await Axios.get('/wlpartner');
  return oResponse.data;
};

export const getPartner = async (nWlpnId) => {
  const oResponse = await Axios.get(`/wlpartner/${nWlpnId}`);
  return oResponse.data;
};

export const createPartner = async (oPartner) => {
  const oResponse = await Axios.post('/wlpartner', oPartner);
  return oResponse.data;
};

export const updatePartner = async (nWlpnId, oPartner) => {
  const oResponse = await Axios.put(`/wlpartner/${nWlpnId}`, oPartner);
  return oResponse.data;
};

export const setPartnerLogo = async (nWlpnId, fdData) => {
  const oResponse = await Axios.post(`/wlpartner/logo/${nWlpnId}`, fdData);
  return oResponse.data;
};

export const deletePartnerLogo = async (nWlpnId, cLogoName) => {
  const oResponse = await Axios.delete(`/wlpartner/logo/${nWlpnId}`, { cLogoName });
  return oResponse.data;
};

export const getLogosSettings = async () => {
  const oResponse = await Axios.get('/logo');
  return oResponse.data;
}

// todo: definir regras para inativar parceiros
// export const deactivatePartner = async (nWlpnId) => {
//   const oResponse = await Axios.delete(`/wlpartner/${nWlpnId}`);
//   return oResponse.data;
// }